export const CARGO_LABELS = {
  documenti: "Documenti",
  pacchi_piccoli: "Pacchi piccoli",
  pacchi_medi: "Pacchi medi",
  pacchi_grandi: "Pacchi grandi / voluminosi",
  pallet: "Bancali / Pallet",
  alimenti: "Alimenti",
  refrigerato: "Carichi refrigerati",
  fragile: "Merce fragile",
  pericoloso: "Merci pericolose (ADR)",
};

export const CARGO_LIST = Object.keys(CARGO_LABELS);

export const VEHICLE_TYPES = [
  { value: "furgone", label: "Furgone" },
  { value: "motrice", label: "Motrice" },
  { value: "bilico", label: "Bilico" },
  { value: "autoarticolato", label: "Autoarticolato" },
  { value: "centinato", label: "Centinato" },
  { value: "frigo", label: "Frigorifero" },
  { value: "isotermico", label: "Isotermico" },
];

export const ROLE_LABELS = {
  private: "Privato",
  carrier: "Trasportatore",
  admin: "Amministratore",
};

export const STATUS_LABELS = {
  pending: "In attesa",
  accepted: "Accettata",
  rejected: "Rifiutata",
  completed: "Completata",
  active: "Attiva",
  cancelled: "Annullata",
};

export function formatEUR(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
}

export function formatCo2(kg) {
  const v = Number(kg || 0);
  if (v >= 1000) return `${(v / 1000).toFixed(1)} t`;
  return `${Math.round(v)} kg`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}
